export enum ConfigurationTab {
    PaymentTerms = 'paymentTerms',
    TaxRates = 'taxRates',
    InvoiceNumberSequence = 'invoiceNumberSequence',
}
